import axios from 'axios'
import {CreateInstance} from './config'
const remoteSessionAPI = CreateInstance('remote_session', 'launcher')
const versionAPI = CreateInstance('/lmmviewer/version.html', 'download')
const launcherAPI = (guid, cb) => {
  return axios.all([remoteSessionAPI.get(guid), versionAPI.get('')])
    .then(axios.spread((sessionResp, versionResp) => {
      if (sessionResp.data.status !== 200) return cb(sessionResp.data.status)
      const session = sessionResp.data.objects[0]
      const version = versionResp.data
      cb(null, {session, version})
    }))
    .catch(err => {
      cb(err)
    })
}
export {remoteSessionAPI, versionAPI}
export default launcherAPI
